// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2cf126ae","977":"345ceb33"}[chunkId] + ".chunk.js";
};